export const MEETING_NOTIFICATION_KEY = 'meetingTranscriptionNotifications';

export interface MeetingNotificationItem {
  sessionId: string;
  title: string;
  status: 'processing' | 'transcribing' | 'completed' | 'failed';
  created_at: string;
  completed_at?: string;
  dismissed?: boolean;
}

export const getMeetingNotifications = (): MeetingNotificationItem[] => {
  try {
    const stored = localStorage.getItem(MEETING_NOTIFICATION_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error getting meeting notifications from localStorage:', error);
    return [];
  }
};

export const saveMeetingNotifications = (notifications: MeetingNotificationItem[]) => {
  try {
    localStorage.setItem(MEETING_NOTIFICATION_KEY, JSON.stringify(notifications));
    window.dispatchEvent(new CustomEvent('meetingNotificationUpdate'));
  } catch (error) {
    console.error('Error saving meeting notifications to localStorage:', error);
  }
};

export const addMeetingNotification = (sessionId: string, title: string): MeetingNotificationItem[] => {
  const notifications = getMeetingNotifications();
  const existing = notifications.findIndex(n => n.sessionId === sessionId);

  if (existing >= 0) {
    notifications[existing] = {
      ...notifications[existing],
      title,
      status: 'processing',
      created_at: new Date().toISOString(),
    };
  } else {
    notifications.push({
      sessionId,
      title,
      status: 'processing',
      created_at: new Date().toISOString(),
    });
  }

  saveMeetingNotifications(notifications);
  return notifications;
};

export const updateMeetingNotificationStatus = (
  sessionId: string,
  status: MeetingNotificationItem['status']
): MeetingNotificationItem[] => {
  const notifications = getMeetingNotifications();
  const index = notifications.findIndex(n => n.sessionId === sessionId);

  if (index >= 0) {
    notifications[index].status = status;
    if (status === 'completed' || status === 'failed') {
      notifications[index].completed_at = new Date().toISOString();
    }
    saveMeetingNotifications(notifications);
  }

  return notifications;
};

export const removeMeetingNotification = (sessionId: string): MeetingNotificationItem[] => {
  const notifications = getMeetingNotifications().filter(n => n.sessionId !== sessionId);
  saveMeetingNotifications(notifications);
  return notifications;
};

export const clearAllMeetingNotifications = () => {
  localStorage.removeItem(MEETING_NOTIFICATION_KEY);
  window.dispatchEvent(new CustomEvent('meetingNotificationUpdate'));
};
